"use client"

import styled from "@emotion/styled"
import { useState } from "react"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"
import CommonTabs from "../Common/CommonTabs"
import TeamGrid from "./TeamGrid"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

export type Team = {
  teamName: string
  teamMainImage: string
  teamDescription: string
  teamRole: string
  teamThumbnailImage: string
  linkedinLink: string
}

export type TeamTab = {
  category: string
  teams: Team[]
}

const StyledLayout = styled.div`
  width: 100%;
  padding-bottom: 40px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-bottom: 64px;
  }
`

type Props = {
  data: any
  blockIndex?: number
  isHomepage?: boolean
}

export default function TeamTabs({ data, blockIndex, isHomepage }: Props) {
  const blocks = extractProperty(data, "itemsList") || []
  const some = blocks.map((block: any) => {
    const category = extractProperty(block, "categoryName")
    const teamsList = extractProperty(block, "teamList") || []
    const teams = teamsList.map((team: any) => {
      const teamName = extractProperty(team, "teamName")
      const teamMainImage = extractProperty(team, "teamMainImage")
      const teamThumbnailImage = extractProperty(team, "teamThumbnailImage")
      const teamDescription = extractProperty(team, "teamDescription")
      const teamRole = extractProperty(team, "teamRole")
      const linkedinLink = extractProperty(team, "linkedinLink")?.[0]?.url
      return {
        teamName,
        teamMainImage,
        teamDescription,
        teamRole,
        linkedinLink,
        teamThumbnailImage,
      }
    }) as Team[]
    return {
      category: category,
      teams: teams,
    }
  }) as {
    category: string
    teams: {
      teamName: string
      teamMainImage: string
      teamDescription: string
      teamRole: string
      linkedinLink: string
      teamThumbnailImage: string
    }[]
  }[]
  const [value, setValue] = useState(0)
  const tabsData = some.map((item, i) => ({
    label: item.category,
    content: <TeamGrid data={item.teams} key={i} />,
  }))
  const isGray = isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1

  return (
    <OuterContainer $isGray={isGray}>
      <StyledLayout>
        <CommonTabs data={tabsData} value={value} setValue={setValue} />
      </StyledLayout>
    </OuterContainer>
  )
}
